export default "__VITE_ASSET__QPf_faB$__"